import React from 'react';
import { Slide, TopSlide, IconWrapper, TextWrapper, HeaderIconWrapper } from './sidebar-styles';
var Sidebar = function (_a) {
    var children = _a.children, visible = _a.visible, menuIcon = _a.menuIcon, topText = _a.topText, toggleSidebar = _a.toggleSidebar, closeIcon = _a.closeIcon, _b = _a.leftBorder, leftBorder = _b === void 0 ? false : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(TopSlide, { visible: visible },
            React.createElement(TextWrapper, null,
                React.createElement(HeaderIconWrapper, null, menuIcon),
                topText),
            React.createElement(IconWrapper, { onClick: toggleSidebar, leftBorder: leftBorder }, closeIcon)),
        React.createElement(Slide, { visible: visible }, children)));
};
export default Sidebar;
